// Tony & Charlie — toont de gekozen kleur en maat naast de optienaam ("COLOR — Navy"), 21-10.
(function () {
  function update() {
    document.querySelectorAll('.product-info .option-block').forEach(function (block) {
      var label = block.querySelector('.option-label');
      if (!label) { return; }
      var checked = block.querySelector('.swatch-radio:checked');
      var span = label.querySelector('.tc-opt-value');
      if (!span) {
        span = document.createElement('span');
        span.className = 'tc-opt-value';
        label.appendChild(span);
      }
      span.textContent = checked ? checked.value : '';
      span.hidden = !checked;
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('swatch-radio')) { setTimeout(update, 0); }
  });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { setTimeout(update, 0); }); }
  else { setTimeout(update, 0); }
  window.addEventListener('load', update);
})();
